export const correctionDrawingStatus = {
    IN_PROGRESS: 'in_progress',
    EXAMINATION: 'examination'
}